import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d678001"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mian" }
const _hoisted_2 = { class: "worp" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "play_bg"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { style: {"margin-left":"12px"} }
const _hoisted_8 = { class: "item_content flex" }
const _hoisted_9 = { class: "con_left" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "con_right" }
const _hoisted_12 = { class: "flex one_line" }
const _hoisted_13 = { class: "flex line_box" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "line_text" }
const _hoisted_16 = { class: "line_text_g" }
const _hoisted_17 = { class: "mar_left" }
const _hoisted_18 = { class: "line_text_g" }
const _hoisted_19 = {
  key: 0,
  class: "flex"
}
const _hoisted_20 = {
  key: 1,
  class: "flex"
}

import { message, Button, Input } from 'ant-design-vue';
import ClipboardJS from 'clipboard';
import { useConsoleStore } from '@/pinia/console';
import { MultiStream } from '@/pinia/types/console';
import EventBus from '@/components/EventBus';
import { playing } from '@/assets';


export default /*#__PURE__*/_defineComponent({
  __name: 'Multilingual',
  setup(__props) {

const aButton = Button;
const aInput = Input;

// 多语 数据
const consoleMulti = useConsoleStore();
const multiStream = consoleMulti.consoleInfo.multiStream;

// 监看 传值id
const messageBrother = (item: MultiStream) => {
  const index = consoleMulti.consoleInfo.qrCodeUrl.lastIndexOf('/');
  consoleMulti.consoleInfo.qrCodeUrl = consoleMulti.consoleInfo.qrCodeUrl.substring(0, index) + '/' + item.id;
  const data = {
    playUrl: item.play_url,
    status: item.live_url_status,
    push_type: item.push_type,
  };
  EventBus.emit('Videoplay', data);
  multiStream.forEach((e) => {
    e.supervision_status = 0;
    if (e.id === item.id) {
      e.supervision_status = 1;
    }
  });
};

//  copy
const copyText = (btns: string) => {
  const ClipboardJSObj = new ClipboardJS(btns);
  ClipboardJSObj.on('success', (e) => {
    message.destroy();
    message.info('复制成功');
    e.clearSelection();
  });
  ClipboardJSObj.on('error', () => {
    message.destroy();
    message.info('复制失败');
  });
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(multiStream), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "item_box"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["item_title flex", { actived: index > 0 }])
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: item.language_image_url,
                class: "item_title_img"
              }, null, 8, _hoisted_4),
              (item.live_url_status === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("img", {
                      src: _unref(playing),
                      class: "play_img"
                    }, null, 8, _hoisted_6)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_7, _toDisplayString(item.title), 1)
            ]),
            _createVNode(_unref(aButton), {
              class: _normalizeClass(["title_but flex", { bus: item.supervision_status === 1 }]),
              size: "small",
              onClick: ($event: any) => (messageBrother(item))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_icon, { "icon-class": "multilingual_monitoring" }),
                _createTextVNode("监看")
              ]),
              _: 2
            }, 1032, ["class", "onClick"])
          ], 2),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("img", {
                src: item.image_player_cover_url
              }, null, 8, _hoisted_10)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["line_but", { actived: item.stream_type === 0 }]),
                    onClick: ($event: any) => (item.stream_type = 0)
                  }, "推流地址", 10, _hoisted_14)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", null, [
                    _createTextVNode("并发量："),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(item.uv_live), 1),
                    _createTextVNode("人")
                  ]),
                  _createElementVNode("span", _hoisted_17, [
                    _createTextVNode("观看量："),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(item.pv_live), 1),
                    _createTextVNode("次")
                  ])
                ])
              ]),
              (item.stream_type === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_unref(aInput), {
                      value: item.push_url,
                      "onUpdate:value": ($event: any) => ((item.push_url) = $event),
                      class: "bg_color",
                      readonly: ""
                    }, null, 8, ["value", "onUpdate:value"]),
                    _createVNode(_unref(aButton), {
                      class: "bg_but push",
                      "data-clipboard-text": item.push_url,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (copyText('.push')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("复制")
                      ]),
                      _: 2
                    }, 1032, ["data-clipboard-text"])
                  ]))
                : _createCommentVNode("", true),
              (item.stream_type === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createVNode(_unref(aInput), {
                      value: item.pull_url,
                      "onUpdate:value": ($event: any) => ((item.pull_url) = $event),
                      class: "bg_color"
                    }, null, 8, ["value", "onUpdate:value"]),
                    _createVNode(_unref(aButton), {
                      class: "bg_but pull",
                      "data-clipboard-text": item.pull_url,
                      disabled: item.pull_url === '',
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (copyText('.pull')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("复制")
                      ]),
                      _: 2
                    }, 1032, ["data-clipboard-text", "disabled"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})